export const PRODUCT_TYPE = "product_type";
export const BUILD_DESIGN = "design";
export const BUILD_TYPE = "design_variant";
export const ENGINE_CONSTRUCTION_VARIANT = "engine_construction_variant";
export const INSTALLATION_POSITION = "installation_position";
export const BUILD_SIZE = "size_code";
export const GEAR_RATIO = "gearreductionratio";
